import { clarityEvent } from "~/services/util";

export default {
  methods: {
    goToPartner(link, partner_name, place) {
      clarityEvent("Partner Click", {
        partner_name: partner_name,
        place: place,
      });
      window.open(link, "_blank");
    },
  },
};
